module.exports = __webpack_public_path__ + "img/item-header-1.bf605f4b.png";